// App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AiVerificationSection from "./components/AiVerificationSection";
import RestDaysFeature from "./components/RestDaysFeature";
import FeatureModes from "./components/FeatureModes";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy"; // New Privacy Policy page

// MainContent for the home page sections
function MainContent() {
  return (
    <>
      <Header />

      {/* Home Section */}
      <Box id="home">
        <HeroSection />
      </Box>

      {/* Features Section */}
      <Box id="features">
        <AiVerificationSection />
      </Box>

      {/* Rest Days Section (if needed) */}
      <Box id="restdays">
        <RestDaysFeature />
      </Box>

      {/* Modes Section */}
      <Box id="modes">
        <FeatureModes />
      </Box>

      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Box
        sx={{
          backgroundColor: "#121212",
          color: "white",
          height: "auto",
        }}
      >
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Box>
    </BrowserRouter>
  );
}

export default App;
